<div class="tooltip" [ngClass]="['tooltip--'+position]" [style.left]="left + 'px'" [style.top]="top + 'px'">
  @if (tooltip) {
    <span>{{(tooltip | translate) ? (tooltip | translate) :tooltip}}</span>
  }
  @if (childTemplate) {
    <span>
      <ng-container [ngTemplateOutlet]="childTemplate"></ng-container>
    </span>
  }
</div>